import styled from 'styled-components';
import { withModifiers } from 'utils';
import { color } from 'styles/settings';

export const CustomBlock = styled.span`
  z-index: -1;
  pointer-events: none;
  //position: relative;

  ${withModifiers('isSelected')`
    span[data-slate-string="true"] {
        color: ${color.neutral.white};
        background-color: ${color.brand.gold};
        
        ${withModifiers('inNote')`
            background-color: ${color.neutral.plainBlack};
        `}
      }
    `}

  ${withModifiers('hasName')`
        padding: 2px 0px;
        background-color: ${color.neutral.grayPaler};
        ${withModifiers('inNote')`
          background-color: ${color.neutral.white};
        `}
        
    `}

  ${withModifiers('isLink')`
        padding: 2px 0px;
        background-color: ${color.neutral.grayPaler};
        ${withModifiers('inNote')`
          background-color: ${color.neutral.white};
        `}
        
    `}
  
  ${withModifiers('highlight')`
        background-color: ${color.brand.goldWithOpacity(0.3)};
    `}

  ${withModifiers('highlight', '$isNote')`
        background-color: ${color.neutral.white};
  `}

  ${withModifiers('strikethrough')`
        text-decoration: line-through;
    `}

  ${withModifiers('underline')`
        text-decoration: underline;
    `}

  ${withModifiers('strikethrough', 'underline')`
        text-decoration: line-through underline;
    `}
`;
